<!-- HTML -->
<template>
  <div>

    <!-- About Section -->
    <BandDescend />
    <!-- Mailing List Section -->
    <HomeMailingList />
    <!-- Albums Section -->
    <HomeFeaturedStore />
    <!-- Footer Section -->
    <HomeFooter />

  </div>
</template>

<!-- JavaScript -->
<script>
// @ is an alias to /src

import BandDescend from "@/components/band/BandDescend.vue";
import HomeFeaturedStore from "@/components/home/HomeFeaturedStore.vue";
import HomeMailingList from "@/components/home/HomeMailingList.vue";
import HomeFooter from "@/components/home/HomeFooter.vue";

export default {

  name: "Home",

  components: {

    BandDescend,
    HomeFeaturedStore,
    HomeMailingList,
    HomeFooter

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
@import "../assets/scss/transitions.scss";


</style>
